import { render } from "./AddWorkspaceModal.vue?vue&type=template&id=0b662805&scoped=true"
import script from "./AddWorkspaceModal.vue?vue&type=script&lang=js"
export * from "./AddWorkspaceModal.vue?vue&type=script&lang=js"

import "./AddWorkspaceModal.vue?vue&type=style&index=0&id=0b662805&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b662805"]])

export default __exports__